import { Field, useFormikContext } from "formik";
import React, { FC, useRef } from "react";
import { useSelector } from 'react-redux';
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { useLocale } from "../../contexts/localeContext";
import useFocusOnRouteChange from "../../hooks/useFocusOnRouteChange";
import { IAppState } from '../../store/types';
import { requiredValidation } from "../../utilities/Validation";
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import Label from "../label/label";
import PaginatedSearchableSelectField from "../selection-field/paginated-searchable-select-field";
import { getMessagesTypeNamesWithPagination } from "@/services/messageService";
import { MESSAGE_TYPE, MESSAGE_TYPES } from "@/constants/messages-constants";

interface MessageCardProps {
    messageType?: MESSAGE_TYPE
}

const MessageCard: FC<MessageCardProps> = ({ messageType}) => {
    const site = useSelector((state: IAppState) => state.site.site.label)
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();

    const inputRef = useRef<HTMLInputElement>(null);
    useFocusOnRouteChange(inputRef);

    return (
        <div className="w-full p-2 inline-flex justify-start items-center bg-white">
            {/* <div className="flex flex-col card-details"> */}
                {values.id ?
                    (<div className="ml-8 mr-5 py-4 card-details">
                        <EntityHierarchy title={values.name} tree={{ label: values.site, node: { label: values.name } }} />
                    </div>) : ""}
            {/* </div> */}
            <div className="flex flex-row py-4 px-8">
                <div className="flex flex-col">
                    <div className="mb-2">
                        <div className="flex flex-row justify-between" id = "siteLabel">
                            <Label
                                htmlFor="siteId"
                                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.site)}:</Label>
                        </div>
                        {values.id
                            ? <Field
                                value={values.site}
                                disabled={true}
                                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                            : <Field
                                value={site}
                                disabled={true}
                                className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}

                    </div>

                    {messageType === MESSAGE_TYPES.ALL && (
                        <div className="mb-2">
                            <div className="flex flex-row justify-between" id="typeLabel">
                                <Label htmlFor="messageTypeId" className="text-xs text-gray-600 mt-1" required>
                                    {translate.byKey(TranslationKeys.type)}:
                                </Label>
                                {errors.messageTypeId ? <span className='text-red-600 text-xs'>{errors.messageTypeId as string}</span> : null}
                            </div>
                            <span id="messageTypeId">
                                {values.id
                                    ? <Field
                                        value={values.messageTypeName}
                                        disabled={true}
                                        className="flex flex-row items-center pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                                    : <PaginatedSearchableSelectField
                                        name={translate.byKey(TranslationKeys.type)}
                                        key={"messageTypeIdKey"}
                                        accessor='messageTypeId'
                                        dataMethod={getMessagesTypeNamesWithPagination}
                                        searchAccessor={'lmtName'}
                                        onSelect={(id, item) => setFieldValue('messageTypeId', id)}
                                        required={true}/>
                                }
                            </span>
                        </div>
                    )}

                    <div>
                        <div className="flex flex-row justify-between" id = "messageLabel">
                            <Label
                                htmlFor="name"
                                className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.message)}:</Label>
                            {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                        </div>

                        <div className="flex flex-row justify-between" id="messagesInputTextArea">
                            <Field
                                as="textarea"
                                type="text"
                                name="name"
                                innerRef={inputRef}
                                className="flex flex-row items-center p-1 text-gray-800 text-sm w-full bg-gray-input"
                                validate={(value) => requiredValidation(value, translate)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MessageCard;
